export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp();
  const auth = useAuthStore();

  if (auth.logged) {
    const userLocale = auth?.user?.preferred_language || 'en';
    const baseRedirectUrl = auth.user.profile.onboarding_complete || auth.user.profile.onboarding_skip ? '/account/profile' : '/onboarding';
    const targetRoute = userLocale === 'en' ? baseRedirectUrl : `/${userLocale}${baseRedirectUrl}`;

    return nuxtApp.runWithContext(() => navigateTo(targetRoute));
  }
});
